// The Ex GST / Inc GST view switch on a Sales Order and its print. It
// starts on the Customer's Pricing Basis (Business ex, Retail inc) and can
// show the other side for reconciling against QuickBooks — view only:
// prices are still typed and saved in the Customer's basis.
// ui-architecture.md "Tax Basis in Column Headings".

export const GST_VIEWS = [
  { key: 'ex', label: 'Ex GST' },
  { key: 'inc', label: 'Inc GST' },
];

const present = (v) => v !== null && v !== undefined && v !== '';
const round2 = (n) => Math.round(Number(n) * 100 + Number.EPSILON) / 100;
const round4 = (n) => Number(Number(n).toFixed(4));

// A form line's unit price ex or inc GST (camelCased like the forms hold a
// line). Inc of a Business price is the ex price grossed up, without
// Retail rounding — it isn't a Retail price.
export function viewUnitPrice(line, gstRate, inc) {
  const rate = Number(gstRate) || 0;
  const hasEx = present(line.unitPrice);
  const hasInc = present(line.unitPriceInc);
  if (!hasEx && !hasInc) return null;
  if (inc) return hasInc ? Number(line.unitPriceInc) : round4(Number(line.unitPrice) * (1 + rate / 100));
  return hasEx ? Number(line.unitPrice) : round4(Number(line.unitPriceInc) / (1 + rate / 100));
}

// A form line's amount ex or inc GST.
export function viewLineAmount(line, inc) {
  const ex = Number(line.extendedPrice || 0);
  if (!inc) return ex;
  return present(line.extendedPriceIncGst) ? Number(line.extendedPriceIncGst) : ex + Number(line.gstAmount || 0);
}

// The lines' Subtotal ex or inc GST.
export function viewSubtotal(lines, inc) {
  return round2(lines.reduce((sum, l) => sum + viewLineAmount(l, inc), 0));
}

// An Order Discount (held in the Customer's basis) ex or inc GST, in step
// with the lines it comes off.
export function viewDiscount(lines, amount, retail, inc) {
  const held = viewSubtotal(lines, retail);
  return held > 0 ? round2(amount * (viewSubtotal(lines, inc) / held)) : 0;
}
